import type { MessagingClient } from '../messaging/sessionStore';
import { WebPersistenceAdapter } from './persistence.web';
// IMPORTANT: explicit `.ts` extension. Vite's web resolver has
// `.web.ts` ahead of `.ts` in the extensions list, so a bare
// `./syncEngine` import from this file resolves back to itself
// (infinite recursion on start/stop/isRunning). Pinning the platform-
// agnostic file by extension breaks the loop. Metro on RN-macOS does
// the same trick via the `syncEngine.macos.ts` sibling.
import {
  isRunning as sharedIsRunning,
  start as sharedStart,
  stop as sharedStop,
} from './syncEngine.ts';

// The shared `packages/ui/` cannot statically import from `apps/web/` —
// that would couple the design system to the web shell and break Metro
// for `apps/desktop/`. Instead the web app registers its IndexedDB module
// at startup; sync.start then reads through this registration.
type WebDbModule = ConstructorParameters<typeof WebPersistenceAdapter>[0];

let registeredDbModule: WebDbModule | null = null;

export function registerWebDbModule(getDbModule: WebDbModule): void {
  registeredDbModule = getDbModule;
}

export function isRunning(): boolean {
  return sharedIsRunning();
}

export async function start(client: MessagingClient): Promise<void> {
  if (registeredDbModule === null) {
    throw new Error(
      'sync.web.start: no DB module registered; call registerWebDbModule() before start()',
    );
  }

  const adapter = new WebPersistenceAdapter(registeredDbModule);
  await sharedStart(client, adapter);
}

export async function stop(): Promise<void> {
  await sharedStop();
}
